import { render, staticRenderFns } from "./MedicoDetalhe.vue?vue&type=template&id=57fe506e"
import script from "./MedicoDetalhe.vue?vue&type=script&lang=js"
export * from "./MedicoDetalhe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports